import React from 'react'
import Card from '@material-ui/core/Card'
import ReactPlayer from 'react-player'

function StoryItemVideo(props) {
  const { asset } = props

  const handleVideoReady = () => {
    window.dispatchEvent(new Event('resize'))
  }

    return(
      <li
        style={{ listStyleType: 'none' }}
      >
        <Card >
            <ReactPlayer
              className="c-player"
              width={'100%'}
              height={'auto'}
              url={asset.link}
              onReady={handleVideoReady}
              controls
              config={
                {
                  file: {
                    attributes: {
                      controlsList: 'nodownload' // prevent users from downloading videos https://github.com/CookPete/react-player/issues/323#issuecomment-364357541
                  }
              }}} />
        </Card>
      </li>
    )

}

export default StoryItemVideo
